import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { ManFile } from '../../../shared/dto/file/manFile';

@Injectable({
	providedIn: 'root',
})
export class ManFileService {
	constructor(private http: HttpClient) {}

	private get token(): string {
		return sessionStorage.getItem('token');
	}

	getAllFile(country: string, active: boolean) {
		return this.http.get<any>(
			environment.financialUrl +
				'/listFile?country=' +
				country +
				'&active=' +
				active,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	getAllMoveFile(
		country: string,
		active: boolean,
		typeTransmission: string,
		typeFile: string,
		startDate: Date,
		endDate: Date
	) {
		let request = '';

		if (country !== undefined) {
			request = 'country=' + country;
		}

		if (active !== undefined) {
			request += request.length > 0 ? '&' : '';
			request += 'active=' + active;
		}

		if (typeTransmission !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'type=' + typeTransmission;
		}

		if (typeFile !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'typeFile=' + typeFile;
		}

		if (startDate !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'startDate=' +
				startDate.toISOString().split('T')[0] +
				'&endDate=' +
				endDate.toISOString().split('T')[0];
		}

		return this.http.get<any>(
			environment.financialUrl + '/moveFile?' + request,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	processFile(id: number) {
		return this.http.get<any>(
			environment.financialUrl + '/processFile?id=' + id,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	putFile(id: number) {
		return this.http.get<any>(
			environment.financialUrl + '/putFile?id=' + id,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	DownloadFile(nameFile: string) {
		return this.http.get(
			environment.financialUrl + '/getFile?file=' + nameFile,
			{
				headers: new HttpHeaders({
					samistoken: environment.samisToken,
					Authorization: `Bearer ${this.token}`,
				}),
				responseType: 'text',
			}
		);
	}

	UploadFile(id: number) {
		return this.http.get<any>(
			environment.financialUrl + '/putFile?id=' + id,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	updateFile(file: ManFile) {
		file.createUser = sessionStorage.getItem('username');
		file.updateUser = sessionStorage.getItem('username');
		return this.http.put(
			environment.financialUrl + '/updateFile/' + file.id,
			file,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}

	createFile(file: ManFile) {
		file.createUser = sessionStorage.getItem('username');
		file.updateUser = sessionStorage.getItem('username');
		file.className = '';
		return this.http.post(environment.financialUrl + '/createFile/', file, {
			headers: {
				Authorization: `Bearer ${this.token}`,
			},
		});
	}

	getTypeFile() {
		return this.http.get<any>(environment.financialUrl + '/typefile', {
			headers: {
				Authorization: `Bearer ${this.token}`,
			},
		});
	}

	getProcessFile(id: number) {
		return this.http.get<any>(
			environment.financialUrl + '/processError?id=' + id,
			{
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			}
		);
	}
}
